import { useEffect, useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "../../../Common/LoadingButton";
import { FaTimes } from "react-icons/fa";
import { IoCutOutline } from "react-icons/io5";
import HoverToolTip from "../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import {
  setStartTime,
  setDuration,
} from "../../../Redux/Actions/VideoHighlightAction";
import {
  setShowTrimmer,
  openVideoEditPopup,
} from "../../../Redux/Actions/VideoHighlightAction";
import styles from "./video-highlight.module.css";
import ReactPlayer from "react-player";
import Sliders from "./Sliders";
import { replaceEditedIntercutVideo } from "../../../Redux/Actions/IntercutVideoActions";
export default function VideoEditDialog() {
  const { isVideoEditPopup, videoEditPopupData, duration, startTime } =
    useSelector((state) => state?.videoHighlightData);
  const dispatch = useDispatch();
  const popupVideoRef = useRef(null);
  const [popupVideoSliderValues, setPopupVideoSliderValues] = useState([1, 2]);
  const [popupVideoMaxDuration, setPopupVideoMaxDuration] = useState(0);
  const [popupVideoPlaybackHandleValue, setPopupVideoPlaybackHandleValue] =
    useState(0);

  useEffect(() => {
    if (isVideoEditPopup) {
      setPopupVideoMaxDuration(
        videoEditPopupData?.videoData?.videoDuration * 100
      );
      setStartTime(dispatch, 1);
      setDuration(dispatch, 2);
      setShowTrimmer(dispatch, true);
    }
  }, [isVideoEditPopup]);

  const handleClose = async () => {
    openVideoEditPopup(dispatch, false);
  };

  const handleCut = async () => {
    replaceEditedIntercutVideo(dispatch, {
      videoEditPopupData: videoEditPopupData,
      startTime: startTime,
      duration: duration,
    });
  };
  return (
    <Dialog
      open={isVideoEditPopup}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      className={`${styles.videoPopupContainer}`}
    >
      <DialogTitle className="d-flex-space-between">
        <p className="bold">
          Edit Video: {videoEditPopupData?.videoData?.eventMediaCategory}
        </p>
        <FaTimes onClick={handleClose} className="crossview cp" />
      </DialogTitle>
      <DialogContent>
        <ReactPlayer
          id="videoPlayer"
          url={videoEditPopupData?.videoData?.videoPath}
          controls
          ref={popupVideoRef}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Sliders
          videoRef={popupVideoRef}
          sliderValues={popupVideoSliderValues}
          setSliderValues={setPopupVideoSliderValues}
          maxDuration={popupVideoMaxDuration}
          playbackHandleValue={popupVideoPlaybackHandleValue}
          setPlaybackHandleValue={setPopupVideoPlaybackHandleValue}
        />
      </DialogActions>
      <DialogActions sx={{ justifyContent: "center" }}>
        <div onClick={handleCut}>
          <HoverToolTip
            content={<span>Trim the video.</span>}
            showToolTip={true}
            variant="sm"
            trigger="hover"
          >
            <LoadingButton
              text={<IoCutOutline style={{ fontSize: "22px" }} />}
              loading={videoEditPopupData?.loading}
              disabled={videoEditPopupData?.loading}
            />
          </HoverToolTip>
        </div>
      </DialogActions>
    </Dialog>
  );
}
